export default function ({ sku = '' }) {
    return {
        sku,
        init() {
            const isAdded = this.isAddedToWishlist();

            if (isAdded) {
                this.$el.classList.add('wishlist-icon-added');
            }
        },
        isAddedToWishlist() {
            const wishlist = this.$store.mageCacheStorage.data.wishlist;

            if (this.sku && wishlist) {
                return wishlist.items.some(
                    (item) => item.product_sku === this.sku
                );
            }
        }
    };
}
